// Centralised constants/config for the image upload widget
export const MAX_IMAGES = 100;
export const VALID_FILE_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.heic', '.gif'];
export const OTHER_FILE_SPECIFIERS = ['image/jpeg', 'image/png', 'image/gif', 'image/heic'];
